import { Link, useNavigate } from "react-router-dom";
import AuthTopBar from "../component/AuthTopBar";
import CustomiseYourAIExperience from "../../FreeTrail/components/CustomiseYourAIExperience";
import { useEffect, useState } from "react";
import ScaleYourAISolutions from "../../FreeTrail/components/ScaleYourAISolutions";
import BusinessDetails from "./BusinessDetails";
import { generateRandomID } from "../../../utils/generateRandomId";
import { useAppServices } from "../../../hook/services";
import { useUserInfo } from "../../../context/user";
import { Toast } from "../../../components/Toast/Toast";

const AccountSetup = () => {
  const [type, setType] = useState("");
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    business_name: "",
    phone_number: "",
    team_size: "",
    business_type: "",
    customer_size: "",
  });
  const [agency_id, setAgencyId] = useState("");
  const Service = useAppServices();
  const navigate = useNavigate();
  const logout = useUserInfo()[2];
  const saveActiveLocation = useUserInfo()[5];
  const userInfo = useUserInfo()[0];
  const updateUser = useUserInfo()[1];
  const [plan_id, setPlanId] = useState("");
  const [products, setProducts] = useState([]);
  const [toast, setToast] = useState({
    message: "",
    type: "error",
    isVisible: false,
    subMessage: "",
  });

  const getting_whitelable_domain = async () => {
    // Extract the domain from the current page URL
    const currentURL = window.location.href; // Get the full URL of the current page
    const urlObject = new URL(currentURL); // Create a URL object
    const domain = urlObject.hostname; // Extract the hostname (domain)
    const payload = {
      domain: domain, // Use the extracted domain
      // domain: "maybe.my-business.link",
    };
    const { response, error } = await Service.agency.getwhitelabel({
      payload: payload,
    });
    if (response) {
      setAgencyId(response.data?._id);
    } else {
      setAgencyId("6739f1be347a7f5974735cec");
    }
  };

  const getAllPlans = async () => {
    const { response, error } = await Service.saas.agencysaas({ query: `agency_id=${agency_id}` })
    if (response?.success)
      setProducts(response?.data)
    else
      console.log(error)

  }

  useEffect(() => {
    if (!agency_id)
      getting_whitelable_domain();
    if (agency_id)
      getAllPlans()
  }, [agency_id]);

  const onTypeClick = (type) => {
    setType(type);
    HandleEveryStep(0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const randomId = generateRandomID(20);
    const payload = {
      ...inputs,
      type: "premium",
      id: randomId,
      agency_id: agency_id,
      email: userInfo.email,
      plan_id: plan_id,
      account_type: type,
      userId: userInfo.userId,
    };
    setLoading(true);
    const { response, error } = await Service.accounts.create({ payload });
    if (response?.success) {
      const { response: userUpdate } =
        await Service.auth.updateLocationAfterSignup({
          payload: {
            userId: userInfo.userId,
            locationId: response?.data?.id,
          },
        });
      if (userUpdate.success) updateUser(userUpdate.data);
      saveActiveLocation(response.data);
      setTimeout(() => { navigate("/onboarding"); }, 300)
    } else {
      setToast({
        message: error.message,
        type: "error",
        subMessage: "Please try again",
        isVisible: true,
      });
    }
    setTimeout(
      () =>
        setToast({
          message: "",
          type: "error",
          subMessage: "",
          isVisible: false,
        }),
      3000
    );
    setLoading(false);
  };

  const HandleEveryStep = async (step) => {

    if (step === 0) {
      await Service.auth.customFields({
        payload: {
          userId: userInfo.userId,
          step: step,
        },
      });
    } else if (step === 1) {
      await Service.auth.customFields({
        payload: {
          userId: userInfo.userId,
          step: step,
        },
      });
    } else if (step === 2) {
      await Service.auth.customFields({
        payload: {
          userId: userInfo.userId,
          step: step,
        },
      });
    } else {
      return;
    }
  }

  return (
    <div className="h-screen bg-white">
      <AuthTopBar />
      <div className="relative flex justify-center">
        {/* <p className="text-[#757575] absolute top-7 right-12">
          Already have an account?{" "}
          <button
            className="text-[#1E1E1E]"
            onClick={() => {
              logout();
              navigate("/auth/sign-in");
            }}
          >
            Sign in
          </button>
        </p> */}
        <div className="text-center mt-14 w-full">
          {!type ? (
            <CustomiseYourAIExperience onTypeClick={onTypeClick} products={products} />
          ) : step === 0 ? (
            <ScaleYourAISolutions
              type={type}
              inputs={inputs}
              setInputs={setInputs}
              onNext={() => { setStep(1); HandleEveryStep(1); }}
              onBack={() => setType(null)}
            />
          ) : (
            <BusinessDetails
              inputs={inputs}
              setInputs={setInputs}
              loading={loading}
              handleSubmit={handleSubmit}
              onBack={() => setStep(0)}
            />
          )}
        </div>
      </div>
      <Toast
        duration={300}
        message={toast.message}
        subMessage={toast.subMessage ?? ""}
        type={toast.type}
        visible={toast.isVisible}
      />
    </div>
  );
};

export default AccountSetup;
